import { schoolYears } from "../helpers/utils";

export const SCHOOL_YEARS = schoolYears();

export const VARIABLE_SYSTEM = [
  {
    key: "${username}",
    value: "User name"
  },
  {
    key: "${email}",
    value: "User email"
  },
  {
    key: "${full_name}",
    value: "User full name"
  },
  {
    key: "${staff_id}",
    value: "Staff ID"
  },
  {
    key: "${student_id}",
    value: "Student ID"
  },
  {
    key: "${student_grade}",
    value: "Student grades"
  }
];
export const TYPE_TEMPLATE = [
  {
    id: "email",
    name: "communication.email_template"
  },
  {
    id: "announcement",
    name: "communication.announcement_template"
  },
  {
    id: "sms",
    name: "communication.sms_template"
  }
];

export const TEACHER_ASSIGNMENTS = {
  PRIMARY: "Primary Teacher",
  SECONDARY: "Secondary Teacher"
};

// Key for preview csv sri smi table
export const smiSriKeys = {
  studentCode: "STUDENT CODE",
  grade: "GRADE",
  smiLastQuantileDate: "SMI LAST QUANTILE DATE",
  smiLastQuantile: "SMI LAST QUANTILE",
  smiLastPerformanceLevel: "SMI LAST PERFORMANCE LEVEL",
  smiNCE: "SMI NCE",
  smiStanine: "SMI STANINE",
  smiGrowthInDateRange: "SMI GROWTH IN DATE RANGE",
  smiTestTaken: "SMI TEST TAKEN",
  sriLastLexileDate: "SRI LAST LEXILE DATE",
  sriLastLexileScore: "SRI LAST LEXILE SCORE",
  sriLastLexilePerormance: "SRI LAST LEXILE PERFORMANCE LEVEL",
  sriPercentile: "SRI PERCENTILE",
  sriNCE: "SRI NCE"
};
export const satKeys = {
  studentCode: "Student code",
  testName: "Test name",
  testDate: "Test date",
  totalScore: "Total Score",
  reading: "Reading",
  writingAndLanguage: "Writing and Language",
  math: "Math"
};

export const actKeys = {
  studentCode: "Student code",
  testDate: "Test date"
};

export const physicalPerformanceKeys = {
  studentCode: "Student code",
  testDate: "Test date"
};

export const sbacKeys = {
  studentCode: "Student code",
  grade: "Grade"
};

export const DEFAULT_OPTION_ALL = [
  {
    id: "",
    name: "common.all"
  }
];

export const DAYS_IN_WEEK = [
  {
    label: "Mon",
    value: "Monday"
  },
  {
    label: "Tue",
    value: "Tuesday"
  },
  {
    label: "Wed",
    value: "Wednesday"
  },
  {
    label: "Thu",
    value: "Thursday"
  },
  {
    label: "Fri",
    value: "Friday"
  },
  {
    label: "Sat",
    value: "Saturday"
  },
  {
    label: "Sun",
    value: "Sunday"
  }
];

export const IELTS_IMPORT_FILE = {
  studentCode: "Student code",
  testName: "Test name",
  overall: "OVERALL",
  listening: "Listening",
  reading: "Reading",
  testDate_s: "Test date S",
  fc: "FC",
  lr: "LR",
  gr: "GR",
  p: "P",
  bandScore_s: "Bandscore S",
  testDate_w: "Test date W",
  task_1: "Task 1",
  task_2: "Task 2",
  bandScore_w: "Bandscore W",
  speakingComment: "Speaking comment",
  writingComment: "Writing comment"
};

export const TOEFL_IMPORT_FILE = {
  studentCode: "Student code",
  testName: "Test name",
  testDate: "Test date",
  totalScore: "Total score(0-120)",
  listening: "Listening(0-30)",
  reading: "Reading(0-30)",
  speaking: "Speaking(0-30)",
  writing: "Writing(0-30)"
};
